import React from 'react';
import { useQuery } from 'react-query';
import { getAllUsers } from '../services/userApi';
import AdminNav from '../components/AdminNav';

const AdminUsersPage = () => {
  const { data: users, isLoading, error } = useQuery('users', getAllUsers);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div style={{ color: 'red' }}>Error: {error.message}</div>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <AdminNav />
     
      <h1>Admin - All Users</h1>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={tableHeaderStyle}>User ID</th>
            <th style={tableHeaderStyle}>Full Name</th>
            <th style={tableHeaderStyle}>Email</th>
            <th style={tableHeaderStyle}>Phone</th>
            <th style={tableHeaderStyle}>Preferred Language</th>
            <th style={tableHeaderStyle}>Country</th>
            <th style={tableHeaderStyle}>Address</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.userId}>
              <td style={tableCellStyle}>{user.userId}</td>
              <td style={tableCellStyle}>{user.fullName}</td>
              <td style={tableCellStyle}>{user.email}</td>
              <td style={tableCellStyle}>{user.phone}</td>
              <td style={tableCellStyle}>{user.preferredLanguage}</td>
              <td style={tableCellStyle}>{user.country}</td>
              <td style={tableCellStyle}>{user.address}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const tableHeaderStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  textAlign: 'left',
  backgroundColor: '#f2f2f2',
};

const tableCellStyle = {
  border: '1px solid #ddd',
  padding: '8px',
};

export default AdminUsersPage;
